import BaseInputContainer from "../../Componant/FormControl/BaseInput";

const BaseInputs = () => {
  return (
    <div className="page-body">
      <BaseInputContainer />
    </div>
  );
};

export default BaseInputs;
